<template>
  <modal :show="show" @close="$emit('close')">
    <v-flex slot="title">Szczegóły regulaminu: {{ terms.name }}</v-flex>

    <div>
      <p class="termsx" v-html="terms.content" />
    </div>

    <v-layout slot="actions">
      <v-spacer />

      <a download :href="config.mediaURL + '/' + terms.mediaId">
        <v-btn flat>Pobierz</v-btn>
      </a>

      <v-btn color="primary" flat @click="$emit('close')">Zamknij</v-btn>
    </v-layout>
  </modal>
</template>
<script>
import { mapState } from 'vuex';

import modal from '@/components/material/Modal';
import { config } from '@/utils/config';

// @vuese
// Modal z szczegółami regulaminu
// @group Terms
export default {
  components: { modal },
  props: {
    // id regulaminu
    id: {
      required: true,
      type: Number,
      default: undefined
    },
    // czy pokazać modal
    show: {
      required: true,
      type: Boolean,
      default: false
    }
  },
  methods: {
    // @vuese
    // Pobiera regulamin
    getTerms() {
      this.$store
        .dispatch('terms/get', this.id)
        .then(() => next())
        .catch(() => () => this.$store.dispatch('notifyError', { title: 'Nie udało się pobrać regulaminu' }));
    }
  },
  data() {
    return {
      config
    };
  },
  computed: mapState({
    terms: state => state.terms.data
  }),
  mounted() {
    this.getTerms();
  }
};
</script>

<style scoped>
.termsx {
  overflow-y: scroll;
  height: 300px;
  width: 100%;
  border: 1px solid #ddd;
  padding: 10px;
}
</style>
